import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		controller: /* @ngInject */ ($scope) => {
			$scope.minimalize = () => {
				let body     = angular.element('body');
				let sideMenu = angular.element('#side-menu');

				body.toggleClass('mini-navbar');
				// body.toggleClass('body-small');

				if (!body.hasClass('mini-navbar') || body.hasClass('body-small')) {
					// Hide menu in order to smoothly turn on when maximize menu
					sideMenu.hide();

					// For smoothly turn on menu
					setTimeout(() => {
						sideMenu.fadeIn(200);
					}, 200);
				} else if (body.hasClass('fixed-sidebar')) {
					sideMenu.hide();

					setTimeout(() => {
						sideMenu.fadeIn(200);
					}, 200);
				} else {
					// Remove all inline style from jquery fadeIn function to reset menu state
					sideMenu.removeAttr('style');
				}
			};
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/minimalizeSidebar/index.js